import { animate, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DoorLock } from 'src/app/model/DoorLock';
import { DoorTimer } from 'src/app/model/DoorTimer';
import { Timer } from 'src/app/model/Timer';
import { CodeDisplayComponent } from './../../common-components/code-display/code-display.component';
import { Game } from './../../model/Game';
import { IOptionItem } from './../../model/IOptionItem';
import { Lock } from './../../model/Lock';
import { GameService } from './../../services/game.service';
import { LockService } from './../../services/lock.service';
import { TimerService } from './../../services/timer.service';

@Component({
  selector: 'app-door-editor',
  templateUrl: './door-editor.component.html',
  styleUrls: ['./door-editor.component.less'],
  animations: [
    trigger("pickerAnimation", [
      transition(':enter', [

        style({ top: "-100vh", bottom: "100vh" }),

        animate('0.4s ease-in-out', style({ top: "9vh", bottom: "4vh" })),
        animate('0.3s ease-in-out', style({ top: "6vh", bottom: "8vh" }))
      ]),
      transition(':leave', [
        animate('0.3s ease-in-out', style({ top: "9vh", bottom: "4vh" })),
        animate('0.4s ease-in-out', style({ top: "-100vh", bottom: "100vh" }))
      ])
    ]),
    trigger("inboundLeft", [
      transition(':enter', [
        style({ 'margin-left': "-100vw", width: "100%" }),
        animate('0.4s ease-in-out', style({ 'margin-left': "10px", width: "110%" })),
        animate('0.2s ease-in-out', style({ width: "100%", 'margin-left': "0" })),
      ]),
      transition(':leave', [
        animate('0.4s ease-in-out', style({ 'margin-left': "10px", width: "110%" })),
        animate('0.2s ease-in-out', style({ width: "100%", 'margin-left': "-100vw" })),
      ])
    ]),
    trigger("codeInOut", [
      transition(':enter', [
        style({ 'margin-top': "-7em", height: "3.5em", opacity: 0 }),
        animate('0.4s 0.7s ease-in-out', style({ 'margin-top': "-3.5em", height: "4em", opacity: 1 })),
        animate('0.2s', style({ 'margin-top': "-4em" })),
      ]),
      transition(':leave', [
        animate('0.4s ease-in-out', style({ 'margin-left': "10px", width: "110%" })),
        animate('0.2s ease-in-out', style({ width: "100%", 'margin-left': "-100vw" })),
      ])
    ]),
  ]
})
export class DoorEditorComponent implements OnInit {

  public displayPicker: boolean = false;
  public timers: Timer[] = [];
  public title: string = "";
  public locks: Lock[] = [];
  public options: IOptionItem[];
  private routeSub: Subscription;
  @ViewChild("codeContainer", { static: false })
  private codeContainer: ElementRef;

  @ViewChild(CodeDisplayComponent, { static: false })
  private display: CodeDisplayComponent;
  public exit: boolean = false;
  public dummyLock = {
    value: "",
    image: "assets/images/lock.png",
    name: "COMPRAR CANDADO",
    description: ""
  }
  public dummyTimer = {
    value: "",
    image: "assets/images/timer.png",
    name: "COMPRAR TEMPORIZADOR",
    description: ""
  }
  public door: Game;
  constructor(private route: ActivatedRoute, private gameService: GameService,
    private timerService: TimerService, private lockService: LockService, private router: Router, private _location: Location) {


  }

  public optionSelected: (i: IOptionItem) => void;
  ngOnInit(): void {
    this.timerService.getAll().then(r => {
      this.timers = r;
    })
    this.lockService.getAll().then(r => {
      this.locks = r;
    })
    this.routeSub = this.route.queryParams.subscribe(p => {
      if (p["id"]) {
        const id: number = Number(p["id"]);
        this.gameService.getDoor(id).then(r => {
          this.door = r;
        })
      } else {
        this.door = new Game();
      }
    })
  }

  public pickLock() {
    this.options = [...this.locks];
    this.title = "ELIJA UN CANDADO";
    this.displayPicker = true;
    this.optionSelected = (i: IOptionItem) => {
      const lock = <Lock>i;
      this.door.lock = new DoorLock(null, lock, lock.durability);
      this.displayPicker = false;
    }
  }
  public save() {
    if (this.doorValid(this.door)) {
      this.gameService.saveDoor(this.door).then(r => {
        this._location.back()
      })
    }
  }
  public pickTimer() {
    this.options = [...this.timers];
    this.title = "ELIJA UN TEMPORIZADOR";
    this.displayPicker = true;
    this.optionSelected = (i: IOptionItem) => {
      const timer = <Timer>i;
      this.door.timer = new DoorTimer(null, timer);
      this.displayPicker = false;
    }
  }
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.codeContainer) return;
    if (this.codeContainer.nativeElement.contains(event.target)) {
      this.display.showKeyboard();
    } else {
      this.display.hideKeyboard();
    }
  }
  public get gameLock() {
    return this.door?.lock?.lock ? this.door.lock.lock : this.dummyLock;
  }

  public doorValid(door: Game) {
    return door.lock && door.timer && door.code;
  }
}
